import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface GetLoginImageResponse {
  imageUrl: string | null;
  enabled: boolean;
}

export const getLoginImageAPI = async (studioId: string) => {
  const response = await baseAPI.get<GetLoginImageResponse>(
    `/studios/login-image/${studioId}`,
  );
  return response.data;
};

export const useGetLoginImageQuery = (studioId: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.LOGIN_IMAGE(studioId),
    queryFn: () => getLoginImageAPI(studioId),
    enabled: !!studioId,
  });
};
